export default __webpack_public_path__ + "static/media/cpd_tile.a97ab31f.jpg";